<template>
    <div class="catalogue">
        <div class="header-tool">
            <div class="header-tool-info">
                <Breadcrumb>
                    <BreadcrumbItem>首页</BreadcrumbItem>
                    <BreadcrumbItem> 标准展台搭建变更申请表</BreadcrumbItem>
                </Breadcrumb>
                <div class="header-tool-title">标准展台搭建变更申请表</div>
            </div>
            <div class="header-tool-box">
                <div class="htb-item" @click="goOne">
                    <span>返回首页</span>
                </div>
            </div>
        </div>
        <div class="marginCss20">
            <p v-if="formList[0]&&formList[0].value" class="fontWig">截止日期：{{ formList[0].value }}</p>
            <div class="paddingCss20 backBlue marginTop20">
                <p v-if="formList[3]&&formList[3].value" v-html="formList[3].value"></p>
            </div>
        </div>
        <div class="marginCss20" style="font-size: 20px;">
            <p>展台基本配置</p>
            <p>-3面展墙(2.5m高×3m宽×3m长，两面开口展位为两面展墙)</p>
            <p>-1张咨询台（1m长×0.5m宽×0.75m高）、2把椅子</p>
            <p>-1个电源插座、2支长臂射灯</p>
            <p>-1条中英文楣板(两面开口展位为2条中英文楣板)</p>
            <p>-地毯</p>
            <p>（展台内配置物品样式及尺寸以现场实物为准）</p>
        </div>

        <div style="padding: 20px">
            <el-table :data="list" style="width: 100%" row-key="id" border
                :tree-props="{ children: 'childrens', hasChildren: 'hasChildren' }" :show-header="false"
                :header-cell-style="{ background: '#fafafa', color: '#333' }">
                <el-table-column prop="name" label="项目" align="center" />
                <el-table-column prop="number" label=" " align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.name != '其它要求'"><el-checkbox v-model="scope.row.remark"></el-checkbox></span>
                        <span v-else><el-input v-model='scope.row.otherRemark' type='text' size="small" maxlength='200'
                                placeholder="请输入" /></span>
                    </template>
                </el-table-column>
            </el-table>
        </div>


        <div class="marginCss20">
            <div class="paddingCss20 backBlue marginTop20">
                <p v-if="formList[4]&&formList[4].value" v-html="formList[4].value"></p>
            </div>
        </div>
        <div class="flexCenter div_btu">
            <el-button type="primary" @click="submitForm('ruleForm')">保存并提交</el-button>
            <el-button @click="goOne">取消</el-button>
        </div>


        <!-- 选择文件上传方式 -->
        <!-- <imgUpload @upload:local="uploadLocal" @upload:material="uploadMaterial" :maxCount="1" v-model="uploadChooseShowed" /> -->
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import imgUpload from "@components/imgUpload/imgUpload.vue";
import { validator } from "@/other/validator";
import config from "@assets/config.json";

export default {
    name: "exhibition-info-catalogue",
    data () {
        return {
            formList: [],
            loading: false,
            IsSubmitDeadlineToo: false,
            list: [
                { name: '光地', remark: false, },
                { name: '增加展墙', remark: false, },
                { name: '拆除展墙，请注明要拆除的展墙两侧的展位号', remark: false, },
                { name: '其它要求', otherRemark: "" },
            ]
        };
    },
    components: {
        // imgUpload,
    },
    computed: {
        ...mapGetters({
            formHeaders: "getFormHeaders",
            uploadUrl: "getUploadUrl",
            joinInfo: "loginModule/getJoinInfo",
            company: "loginModule/getCompany",
            exhibition: "loginModule/getExhibition",

            exhibitor: "loginModule/getExhibitor",
        }),
        exhibitionId () {
            return this.exhibition.id;
        },
    },
    created () {
         
        this.init();
        this.init2();
    },
    methods: {
        ...mapActions({

            downFile: "exhibitionModule/downFile",

            setManageSettingQ: 'hostSetModule/setManageSettingQ', //
            standardboothconstructionchangerecordPost: "exhibitionModuleY/standardboothconstructionchangerecordPost",
            standardboothconstructionchangerecordGet: "exhibitionModuleY/standardboothconstructionchangerecordGet",
        }),
        goOne () {
            this.$router.push(`/exhibition/index/home`);

        },

        async init () {
            let opt = {
                providerName: "Global",
                // providerKey: this.exhibition.id,
                names: ['StandardBoothConstructionChange.SubmitDeadline', 'StandardBoothConstructionChange.IsSubmitDeadlineToo', 'StandardBoothConstructionChange.IsRequired', 'StandardBoothConstructionChange.FormDescription', 'StandardBoothConstructionChange.ContractDescription']
            }
            let res = await this.setManageSettingQ(opt)
            if (res) {
                this.formList = res
                this.IsSubmitDeadlineToo = res[1].value
            }
        },
        // 获取列表
        async init2 () {
            let res = await this.standardboothconstructionchangerecordGet(this.exhibitor.id);
            this.list[3].otherRemark= res.otherRemark
                let data=JSON.parse(res.preBookJson)
                data.map(e=>{
                    if(e.name=='光地'){
                        this.list[0].remark= e.remark=='是'?true:false
                    }
                    if(e.name=='增加展墙'){
                        this.list[1].remark= e.remark=='是'?true:false
                    }
                    if(e.name=='拆除展墙，请注明要拆除的展墙两侧的展位号'){
                        this.list[2].remark= e.remark=='是'?true:false
                    }
                })
        },
     

        async submitForm (name) {
            let bool = this.regular.contrastDate(this.regular.compareDate(), this.endDate)
            // 为true 截止日期到了 不能提交
            if (bool) {
                console.log(bool);
                console.log(this.IsSubmitDeadlineToo,typeof(this.IsSubmitDeadlineToo));
                if (this.IsSubmitDeadlineToo=='false') {
                    this.$message.warning("超过截止日期不能提交");
                    return
                }
            }

            let listOpt = []
            let dataOpt = {}
            this.list.map(e => {
                if (e.remark) {
                    dataOpt.name = e.name
                    dataOpt.remark = e.remark?"是":'否'
                    listOpt.push(dataOpt)
                    dataOpt = {}
                }
            })
            let opt = {
                exhibitorId: this.exhibitor.id,
                body: {
                    preBookJson: JSON.stringify(listOpt),
                    otherRemark:this.list[3].otherRemark?this.list[3].otherRemark:""
                }
            }
            let result = await this.standardboothconstructionchangerecordPost(opt);
            if (result) {
                this.$Message.success("保存成功");
                this.init();
                this.init2();
            }
        },


    },
};
</script>

<style lang="scss">
.intTextarea {
    .ivu-form-item-error-tip {
        top: 75%;
    }
}

.no-label {
    .ivu-form-item-label:before {
        opacity: 0 !important;
    }
}
</style>
<style scoped lang="scss"></style>
